import { render, staticRenderFns } from "./Formular.vue?vue&type=template&id=0159c304&scoped=true"
import script from "./Formular.vue?vue&type=script&lang=js"
export * from "./Formular.vue?vue&type=script&lang=js"
import style0 from "./Formular.vue?vue&type=style&index=0&id=0159c304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0159c304",
  null
  
)

export default component.exports